'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cart = require('./Cart');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cart).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Cart/index.js
// module id = 1141
// module chunks = 1